import React, { useContext } from 'react';
import { LanguageContext } from '../App';
import { ChevronDownIcon, DownloadIcon, CalendarIcon, TruckIcon, PackageIcon, UserIcon, ClockIcon, DollarSignIcon, BarChart3Icon, MapPinIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { pageTransition, slideUp, fadeIn } from '../utils/animations';
import { CountUp } from '../components/ui/CountUp';
export const Reports: React.FC = () => {
  const {
    language
  } = useContext(LanguageContext);
  const driverAvatars = ['https://i.ibb.co/xG0Jcnm/driver1.jpg', 'https://i.ibb.co/k2V6YPL/driver2.jpg', 'https://i.ibb.co/0hFTSyy/driver3.jpg', 'https://i.ibb.co/wdQSrBL/driver4.jpg', 'https://i.ibb.co/bRZmtTG/driver5.jpg'];
  return <motion.div className="space-y-6" variants={pageTransition} initial="hidden" animate="visible" exit="exit" data-id="element-1100">
      <motion.div className="flex justify-between items-center" variants={slideUp} data-id="element-1101">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-1102">
          {language === 'en' ? 'Reports & Analytics' : 'التقارير والتحليلات'}
        </h2>
        <div className="flex space-x-3" data-id="element-1103">
          <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-md flex items-center text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1104">
            <CalendarIcon size={14} className="mr-1.5" data-id="element-1105" />
            {language === 'en' ? 'Last 30 Days' : 'آخر 30 يوم'}
            <ChevronDownIcon size={14} className="ml-1.5" data-id="element-1106" />
          </button>
          <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-md flex items-center text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1107">
            <DownloadIcon size={14} className="mr-1.5" data-id="element-1108" />
            {language === 'en' ? 'Export Report' : 'تصدير التقرير'}
          </button>
        </div>
      </motion.div>
      {/* Summary Cards */}
      <motion.div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" variants={fadeIn} data-id="element-1109">
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1110">
          <div className="flex justify-between items-start" data-id="element-1111">
            <div data-id="element-1112">
              <p className="text-sm font-medium text-gray-600" data-id="element-1113">
                {language === 'en' ? 'Total Orders' : 'إجمالي الطلبات'}
              </p>
              <p className="mt-2 text-3xl font-bold text-gray-900" data-id="element-1114">
                <CountUp to={500} data-id="element-1115" />
              </p>
              <div className="mt-2 flex items-center" data-id="element-1116">
                <span className="text-sm font-medium text-green-600" data-id="element-1117">
                  +8.2%
                </span>
                <span className="text-sm text-gray-500 ml-1" data-id="element-1118">
                  {language === 'en' ? 'vs last month' : 'مقارنة بالشهر الماضي'}
                </span>
              </div>
            </div>
            <div className="p-3 rounded-full bg-regent-st-blue-50" data-id="element-1119">
              <PackageIcon size={24} className="text-regent-st-blue-600" data-id="element-1120" />
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1121">
          <div className="flex justify-between items-start" data-id="element-1122">
            <div data-id="element-1123">
              <p className="text-sm font-medium text-gray-600" data-id="element-1124">
                {language === 'en' ? 'Active Drivers' : 'السائقين النشطين'}
              </p>
              <p className="mt-2 text-3xl font-bold text-gray-900" data-id="element-1125">
                <CountUp to={120} data-id="element-1126" />
              </p>
              <div className="mt-2 flex items-center" data-id="element-1127">
                <span className="text-sm font-medium text-green-600" data-id="element-1128">
                  +12.5%
                </span>
                <span className="text-sm text-gray-500 ml-1" data-id="element-1129">
                  {language === 'en' ? 'vs last month' : 'مقارنة بالشهر الماضي'}
                </span>
              </div>
            </div>
            <div className="p-3 rounded-full bg-congress-blue-50" data-id="element-1130">
              <TruckIcon size={24} className="text-congress-blue-600" data-id="element-1131" />
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1132">
          <div className="flex justify-between items-start" data-id="element-1133">
            <div data-id="element-1134">
              <p className="text-sm font-medium text-gray-600" data-id="element-1135">
                {language === 'en' ? 'Revenue' : 'الإيرادات'}
              </p>
              <p className="mt-2 text-3xl font-bold text-gray-900" data-id="element-1136">
                KWD <CountUp to={18542.75} decimals={2} data-id="element-1137" />
              </p>
              <div className="mt-2 flex items-center" data-id="element-1138">
                <span className="text-sm font-medium text-green-600" data-id="element-1139">
                  +15.3%
                </span>
                <span className="text-sm text-gray-500 ml-1" data-id="element-1140">
                  {language === 'en' ? 'vs last month' : 'مقارنة بالشهر الماضي'}
                </span>
              </div>
            </div>
            <div className="p-3 rounded-full bg-green-50" data-id="element-1141">
              <DollarSignIcon size={24} className="text-green-600" data-id="element-1142" />
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1143">
          <div className="flex justify-between items-start" data-id="element-1144">
            <div data-id="element-1145">
              <p className="text-sm font-medium text-gray-600" data-id="element-1146">
                {language === 'en' ? 'Avg. Delivery Time' : 'متوسط وقت التوصيل'}
              </p>
              <p className="mt-2 text-3xl font-bold text-gray-900" data-id="element-1147">
                <CountUp to={28} data-id="element-1148" /> <span className="text-xl" data-id="element-1149">min</span>
              </p>
              <div className="mt-2 flex items-center" data-id="element-1150">
                <span className="text-sm font-medium text-red-600" data-id="element-1151">+2.1%</span>
                <span className="text-sm text-gray-500 ml-1" data-id="element-1152">
                  {language === 'en' ? 'vs last month' : 'مقارنة بالشهر الماضي'}
                </span>
              </div>
            </div>
            <div className="p-3 rounded-full bg-yellow-50" data-id="element-1153">
              <ClockIcon size={24} className="text-yellow-600" data-id="element-1154" />
            </div>
          </div>
        </div>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1155">
        {/* Orders by Day Chart */}
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1156">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1157">
            {language === 'en' ? 'Orders by Day' : 'الطلبات حسب اليوم'}
          </h3>
          <div className="h-64 bg-gray-50 rounded-lg border border-gray-100 flex items-end p-4" data-id="element-1158">
            {/* Simple bar chart visualization */}
            {[45, 62, 78, 56, 89, 95, 72].map((value, index) => <div key={index} className="flex flex-col items-center flex-1" data-id="element-1159">
                <div className="w-full mx-1 rounded-t bg-congress-blue-500" style={{
              height: `${value / 100 * 80}%`
            }} data-id="element-1160"></div>
                <div className="text-xs text-gray-500 mt-2" data-id="element-1161">
                  {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'][index]}
                </div>
              </div>)}
          </div>
        </div>
        {/* Orders by Status Chart */}
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1162">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1163">
            {language === 'en' ? 'Orders by Status' : 'الطلبات حسب الحالة'}
          </h3>
          <div className="h-64 flex items-center justify-center" data-id="element-1164">
            <div className="w-48 h-48 rounded-full border-8 border-gray-100 relative" data-id="element-1165">
              {/* Pie chart segments */}
              <div className="absolute inset-0 border-8 border-t-green-500 border-r-green-500 border-b-transparent border-l-transparent rounded-full" style={{
              transform: 'rotate(45deg)'
            }} data-id="element-1166"></div>
              <div className="absolute inset-0 border-8 border-t-transparent border-r-transparent border-b-yellow-500 border-l-yellow-500 rounded-full" style={{
              transform: 'rotate(45deg)'
            }} data-id="element-1167"></div>
              <div className="absolute inset-0 border-8 border-t-transparent border-r-red-500 border-b-transparent border-l-transparent rounded-full" style={{
              transform: 'rotate(45deg)'
            }} data-id="element-1168"></div>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-1169">
                <div className="text-center" data-id="element-1170">
                  <div className="text-2xl font-bold text-gray-900" data-id="element-1171">
                    <CountUp to={500} data-id="element-1172" />
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-1173">
                    {language === 'en' ? 'Total Orders' : 'إجمالي الطلبات'}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center space-x-6 mt-4" data-id="element-1174">
            <div className="flex items-center" data-id="element-1175">
              <div className="w-3 h-3 bg-green-500 rounded-full mr-2" data-id="element-1176"></div>
              <span className="text-sm text-gray-600" data-id="element-1177">
                {language === 'en' ? 'Delivered (65%)' : 'تم التوصيل (65%)'}
              </span>
            </div>
            <div className="flex items-center" data-id="element-1178">
              <div className="w-3 h-3 bg-yellow-500 rounded-full mr-2" data-id="element-1179"></div>
              <span className="text-sm text-gray-600" data-id="element-1180">
                {language === 'en' ? 'In Progress (30%)' : 'قيد التنفيذ (30%)'}
              </span>
            </div>
            <div className="flex items-center" data-id="element-1181">
              <div className="w-3 h-3 bg-red-500 rounded-full mr-2" data-id="element-1182"></div>
              <span className="text-sm text-gray-600" data-id="element-1183">
                {language === 'en' ? 'Cancelled (5%)' : 'ملغي (5%)'}
              </span>
            </div>
          </div>
        </div>
        {/* Popular Delivery Areas */}
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1184">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1185">
            {language === 'en' ? 'Popular Delivery Areas' : 'مناطق التوصيل الشائعة'}
          </h3>
          <div className="space-y-4" data-id="element-1186">
            <div className="flex items-center justify-between" data-id="element-1187">
              <div className="flex items-center" data-id="element-1188">
                <MapPinIcon size={16} className="text-congress-blue-500 mr-2" data-id="element-1189" />
                <span className="text-sm font-medium" data-id="element-1190">
                  {language === 'en' ? 'Kuwait City' : 'مدينة الكويت'}
                </span>
              </div>
              <div className="text-sm font-bold" data-id="element-1191">
                <CountUp to={125} data-id="element-1192" /> {language === 'en' ? 'orders' : 'طلب'}
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1193">
              <div className="bg-congress-blue-600 h-2.5 rounded-full" style={{
              width: '85%'
            }} data-id="element-1194"></div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1195">
              <div className="flex items-center" data-id="element-1196">
                <MapPinIcon size={16} className="text-congress-blue-500 mr-2" data-id="element-1197" />
                <span className="text-sm font-medium" data-id="element-1198">
                  {language === 'en' ? 'Salmiya' : 'السالمية'}
                </span>
              </div>
              <div className="text-sm font-bold" data-id="element-1199">
                <CountUp to={108} data-id="element-1200" /> {language === 'en' ? 'orders' : 'طلب'}
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1201">
              <div className="bg-congress-blue-600 h-2.5 rounded-full" style={{
              width: '72%'
            }} data-id="element-1202"></div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1203">
              <div className="flex items-center" data-id="element-1204">
                <MapPinIcon size={16} className="text-congress-blue-500 mr-2" data-id="element-1205" />
                <span className="text-sm font-medium" data-id="element-1206">
                  {language === 'en' ? 'Hawally' : 'حولي'}
                </span>
              </div>
              <div className="text-sm font-bold" data-id="element-1207">
                <CountUp to={94} data-id="element-1208" /> {language === 'en' ? 'orders' : 'طلب'}
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1209">
              <div className="bg-congress-blue-600 h-2.5 rounded-full" style={{
              width: '55%'
            }} data-id="element-1210"></div>
            </div>
            <div className="flex items-center justify-between" data-id="element-1211">
              <div className="flex items-center" data-id="element-1212">
                <MapPinIcon size={16} className="text-congress-blue-500 mr-2" data-id="element-1213" />
                <span className="text-sm font-medium" data-id="element-1214">
                  {language === 'en' ? 'Jabriya' : 'الجابرية'}
                </span>
              </div>
              <div className="text-sm font-bold" data-id="element-1215">
                <CountUp to={86} data-id="element-1216" /> {language === 'en' ? 'orders' : 'طلب'}
              </div>
            </div>
            <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-1217">
              <div className="bg-congress-blue-600 h-2.5 rounded-full" style={{
              width: '48%'
            }} data-id="element-1218"></div>
            </div>
          </div>
        </div>
        {/* Driver Activity */}
        <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1219">
          <h3 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1220">
            {language === 'en' ? 'Driver Activity' : 'نشاط السائقين'}
          </h3>
          <div className="space-y-6" data-id="element-1221">
            <div className="flex items-center justify-center space-x-8" data-id="element-1222">
              <div className="text-center" data-id="element-1223">
                <div className="text-3xl font-bold text-congress-blue-600" data-id="element-1224">
                  <CountUp to={120} data-id="element-1225" />
                </div>
                <div className="text-sm text-gray-500" data-id="element-1226">
                  {language === 'en' ? 'Active Drivers' : 'السائقين النشطين'}
                </div>
              </div>
              <div className="text-center" data-id="element-1227">
                <div className="text-3xl font-bold text-gray-500" data-id="element-1228">
                  <CountUp to={22} data-id="element-1229" />
                </div>
                <div className="text-sm text-gray-500" data-id="element-1230">
                  {language === 'en' ? 'Offline Drivers' : 'السائقين غير المتصلين'}
                </div>
              </div>
              <div className="text-center" data-id="element-1231">
                <div className="text-3xl font-bold text-green-600" data-id="element-1232">
                  <CountUp to={4.7} decimals={1} data-id="element-1233" />
                </div>
                <div className="text-sm text-gray-500" data-id="element-1234">
                  {language === 'en' ? 'Average Rating' : 'متوسط التقييم'}
                </div>
              </div>
            </div>
            <div className="space-y-3" data-id="element-1235">
              <h4 className="text-sm font-medium text-gray-700" data-id="element-1236">
                {language === 'en' ? 'Top Performing Drivers' : 'أفضل السائقين أداءً'}
              </h4>
              <div className="space-y-2" data-id="element-1237">
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded-md" data-id="element-1238">
                  <div className="flex items-center" data-id="element-1239">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-1240">
                      <img src={driverAvatars[0]} alt="Rahul Sharma" className="w-full h-full object-cover" data-id="element-1241" />
                    </div>
                    <div className="ml-3" data-id="element-1242">
                      <div className="text-sm font-medium" data-id="element-1243">Rahul Sharma</div>
                      <div className="text-xs text-gray-500" data-id="element-1244">
                        <CountUp to={145} data-id="element-1245" />{' '}
                        {language === 'en' ? 'deliveries' : 'توصيلة'}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1246">
                    <div className="text-sm font-medium text-yellow-600" data-id="element-1247">
                      ★ <CountUp to={4.9} decimals={1} data-id="element-1248" />
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded-md" data-id="element-1249">
                  <div className="flex items-center" data-id="element-1250">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-1251">
                      <img src={driverAvatars[1]} alt="Ahmed Khan" className="w-full h-full object-cover" data-id="element-1252" />
                    </div>
                    <div className="ml-3" data-id="element-1253">
                      <div className="text-sm font-medium" data-id="element-1254">Ahmed Khan</div>
                      <div className="text-xs text-gray-500" data-id="element-1255">
                        <CountUp to={132} data-id="element-1256" />{' '}
                        {language === 'en' ? 'deliveries' : 'توصيلة'}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1257">
                    <div className="text-sm font-medium text-yellow-600" data-id="element-1258">
                      ★ <CountUp to={4.8} decimals={1} data-id="element-1259" />
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between p-2 bg-gray-50 rounded-md" data-id="element-1260">
                  <div className="flex items-center" data-id="element-1261">
                    <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0" data-id="element-1262">
                      <img src={driverAvatars[2]} alt="Farhan Qureshi" className="w-full h-full object-cover" data-id="element-1263" />
                    </div>
                    <div className="ml-3" data-id="element-1264">
                      <div className="text-sm font-medium" data-id="element-1265">Farhan Qureshi</div>
                      <div className="text-xs text-gray-500" data-id="element-1266">
                        <CountUp to={128} data-id="element-1267" />{' '}
                        {language === 'en' ? 'deliveries' : 'توصيلة'}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center" data-id="element-1268">
                    <div className="text-sm font-medium text-yellow-600" data-id="element-1269">
                      ★ <CountUp to={4.7} decimals={1} data-id="element-1270" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
};